var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProductEffects = function SvgIconProductEffects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    fillRule: "evenodd",
    d: "M10 8.958a.52.52 0 0 1 .52.521v1.563h1.563a.52.52 0 0 1 0 1.041h-1.562v1.563a.521.521 0 0 1-1.042 0v-1.563H7.917a.52.52 0 0 1 0-1.041h1.562V9.479A.52.52 0 0 1 10 8.96",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M5.833 3.23H4.792a2.083 2.083 0 0 0-2.084 2.082V16.25a2.083 2.083 0 0 0 2.084 2.083h10.416a2.084 2.084 0 0 0 2.084-2.083V5.312a2.083 2.083 0 0 0-2.084-2.083h-1.041v1.042h1.041a1.04 1.04 0 0 1 1.042 1.041V16.25a1.04 1.04 0 0 1-1.042 1.042H4.792A1.04 1.04 0 0 1 3.75 16.25V5.312a1.04 1.04 0 0 1 1.042-1.041h1.041z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M11.563 2.708a.52.52 0 0 1 .52.521v1.042a.52.52 0 0 1-.52.52H8.437a.52.52 0 0 1-.52-.52V3.229a.52.52 0 0 1 .52-.52zM8.437 1.667a1.563 1.563 0 0 0-1.562 1.562v1.042a1.563 1.563 0 0 0 1.562 1.562h3.126a1.56 1.56 0 0 0 1.562-1.562V3.229a1.56 1.56 0 0 0-1.562-1.562z"
  })));
};
export default SvgIconProductEffects;